import { Redirect, Route, Switch } from 'react-router-dom';

import { Container, Footer, NavBar, Wrapper } from '../Common/Layout';
import { Routes } from '../Common/useNavigation';
import { useParticipant } from './ParticipantProvider';
import CharityPage from './Registrations/Charity/CharityPage';
import Guard from './Guard';
import MailPreferencesPage from './MailPreferences/MailPreferencesPage';
import OrderPage from './Registrations/Orders/OrderPage';
import OrdersPage from './Registrations/Orders/OrdersPage';
import RegistrationsPage from './Registrations/RegistrationsPage';
import UI from '../../common/UI';
import UpgradesPage from './Registrations/Upgrades/UpgradesPage';
import useAtletaEmbed from '../../common/useAtletaEmbed';
import useProject from '../useProject';

const Dashboard = () => {
  const { participant, impersonating } = useParticipant();
  const project = useProject();

  useAtletaEmbed();

  const impersonatedUsername = impersonating ? participant?.first_name : null;

  return (
    <Wrapper>
      <NavBar impersonatedUsername={impersonatedUsername} />

      <Container>
        {!project && (
          <UI.PageLoader />
        )}

        {project && (
          <Switch>
            <Route
              path={Routes.Upgrades}
              render={({ match: { params: { participantId, eventId, token } } }) => (
                <Guard scopedParticipant={{ id: participantId }}>
                  <UpgradesPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                </Guard>
              )}
            />

            {/* Not guarded, can be accessed with token  */}
            <Route
              path={Routes.MailPreferences}
              render={({ match: { params: { participantId } } }) => (
                <MailPreferencesPage participantId={participantId} />
              )}
            />

            <Route
              path={Routes.Order}
              render={({ match: { params: { participantId, eventId, orderId, token } } }) => (
                <Guard scopedParticipant={{ id: participantId }}>
                  <OrderPage
                    participantId={participantId}
                    eventId={eventId}
                    orderId={orderId}
                    token={token}
                  />
                </Guard>
              )}
            />

            <Route
              path={Routes.Orders}
              render={({ match: { params: { participantId, eventId, token } } }) => (
                <Guard scopedParticipant={{ id: participantId }}>
                  <OrdersPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                </Guard>
              )}
            />

            <Route
              path={Routes.Charity}
              render={({ match: { params: { participantId, eventId, token } } }) => (
                <Guard scopedParticipant={{ id: participantId }}>
                  <CharityPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                </Guard>
              )}
            />

            <Route
              path={Routes.Registrations}
              render={({ match: { params: { participantId, eventId, token } } }) => (
                <Guard scopedParticipant={{ id: participantId }}>
                  <RegistrationsPage
                    participantId={participantId}
                    eventId={eventId}
                    token={token}
                  />
                </Guard>
              )}
            />

            <Redirect to={Routes.Portal} />
          </Switch>
        )}

        <Footer project={project} participant={participant} />
      </Container>
    </Wrapper>
  );
};

export default Dashboard;
